import React from 'react'

interface StatusPillProps {
  label: string
  // A lapsed plan is called out in red.
  expired: boolean
  // A plan still in force is called out in green.
  active?: boolean
}

type Tone = 'expired' | 'active' | 'none'

const TONE: Record<Tone, { box: string; dot: string; text: string }> = {
  expired: {
    box: 'border-danger-200 bg-danger-50',
    dot: 'bg-danger',
    text: 'font-bold text-danger',
  },
  active: {
    box: 'border-success-200 bg-success-50',
    dot: 'bg-success',
    text: 'font-bold text-success-700',
  },
  none: {
    box: 'border-line-200 bg-white',
    dot: 'bg-line-300',
    text: 'text-ink-500',
  },
}

/** "Current plan: …" chip at the top of the page. */
function StatusPill({ label, expired, active }: StatusPillProps) {
  // Pick one tone: expired wins, then active, otherwise the neutral free state.
  let tone: Tone = 'none'
  if (expired) tone = 'expired'
  else if (active) tone = 'active'
  const t = TONE[tone]
  return (
    <span
      className={`mb-4 inline-flex items-center gap-2 rounded-pill border px-3.5 py-1.5 ${t.box}`}
    >
      <span className={`h-2 w-2 shrink-0 rounded-full ${t.dot}`} />
      <span className={`whitespace-nowrap text-13 leading-none ${t.text}`}>
        Current plan: {label}
      </span>
    </span>
  )
}

StatusPill.defaultProps = {
  active: false,
}

export default StatusPill
